import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var newBlockAccordion = function newBlockAccordion(block) {
  return {
    title: block.title,
    mobileIdx: block.mobileIdx,
    content: {
      links: block.data
    }
  };
};
export var reducedAndSortedMobileLinks = function reducedAndSortedMobileLinks(blocks) {
  return _toConsumableArray(blocks).reduce(function (acc, block) {
    if (block.type === 'links') {
      acc.push(newBlockAccordion(block));
    }
    if (block.type === 'groupLinks') {
      acc.push.apply(acc, _toConsumableArray(block.data.map(function (currBlock) {
        return newBlockAccordion(currBlock);
      })));
    }
    return acc;
  }, []).sort(function (a, b) {
    return a.mobileIdx - b.mobileIdx;
  });
};